<template>
    <div>
     <b-modal size="xl" :id="ModalId" 
      @shown="prepararDrag"
       :modal-class="'is-draggable'"
     :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc 
     :title="TitleWindow" ref="modalAddGoals" @close="this.emitEventCancel"
      @ok="this.emitEventOK" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 

        <b-row>
            <b-col lg="12" md="12" sm="12">     
                <MdTitle v-bind:Text="$t('modalAddGoal.goals')" v-bind:isSubtitle="true" v-bind:Name="'Goals'" class="subtitleWizard"/>    
                <MdCheckListBox2 
                v-model="GoalsModel"
                v-bind:Options="GoalsList"            
                v-bind:OnChangeProp="OnChangeGoals"
                v-bind:columnCount="1"
                :textField="'description'"
                :valueField="'code'"/> 
            </b-col>                                   
          </b-row>  

        
        <b-row class="mt-2">
            
            <b-col md="12">
                <MdTitle v-bind:Text="$t('Shared.Other')" v-bind:isSubtitle="true" v-bind:Name="'Other'"/>  
                <MdMemo v-bind:Name="'goaldescription'" v-bind:Rows="'4'" v-bind:UseDinamicClass="false"
                            v-bind:DynamicClass="'modalTextarea'" v-bind:MaxRows="'6'"
                            v-model="goaldescriptionBlank" />
            </b-col>
           </b-row>    
       
     </b-modal>  
    </div>
</template>
 
 <script>
 //import Utils from '@/common/utils'
 import ShowMessage from '@/components/messages/ShowMessage.js'
 import TreatmentPlan from '@/services/treatmentplan.service'
 

 export default {
   name: 'ModalAddGoals',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     TitleWindow: String,
     ProblemRecId:String,
     groupId:Number,
     headerId:String,
     probCode:String
   },
   
   data(){
     return {
        goaldescriptionBlank:"",
        GoalsList:[],
        GoalsModel:[],
        Goaldata:[],
     }
   },
 
   methods:{
     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    if (outer.classList.contains("is-draggable")) 
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
     emitEventOK(/*bvModalEvent*/){
      this.AddGoal();      
     },

     getDescrByCode(code){
        let result = "";
        for(var i = 0; i < this.GoalsList.length; i++){
           if(this.GoalsList[i].code === code){
            result = this.GoalsList[i].description;
            break;
           }
        }
        return result;
     },

     PrepareData(){
            this.Goaldata = [];         
            for(var i = 0; i < this.GoalsModel.length; i++){
                let descrp = this.getDescrByCode(this.GoalsModel[i]);
                this.Goaldata.push(
                    {
                        probRecId: this.ProblemRecId.toString(),
                        goalCode:this.GoalsModel[i].toString(),
                        goalDesc:descrp,
                    }
                    );
            }

            if(this.goaldescriptionBlank.length > 0){
                this.Goaldata.push(
                    {
                        probRecId: this.ProblemRecId.toString(),
                        goalCode:"0",
                        goalDesc:this.goaldescriptionBlank,
                    }
                    );
            }
        },

        AddGoal(){        
        this.PrepareData();
        if(this.Goaldata.length > 0){
            var objdata = {
              goals:this.Goaldata
            };
         TreatmentPlan.AddGoal(objdata)
            .then((response) => { 
               if(response.data){ 
                this.$emit('RefreshGetTP');               
                setTimeout(() => 
                        this.$bvToast.toast(this.$t('treatmentplan.GoalSaved'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 5); 
               }             
            })
            .catch((error) => {
                if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
                }     
                   else if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }   
                     else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }    
            });
        }
        
    },

     OnChangeGoals(){

     },

    async getMedezTxGoals() {
            this.$emit('load', true);
            var parameter = {               
                GroupId: this.groupId,
                ProblemNumber: this.probCode,
                HeaderId:this.headerId
            };
           await TreatmentPlan.getMedTxGoals(parameter)
                .then((response) => {
                if (response.status == '200' && response.data) {
                    this.GoalsList = response.data;
                }
                this.$emit('load', false);
            })
                .catch(error => {
                this.$emit('load', false);
                if (!error.response) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                }
                else if (error.response.status === 400) {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
                else if (error.response.status === 500) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                }
                else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
            });
        },

     emitEventCancel(){
      this.$emit('ModalTPGoal');
    },    
   },
 
  async mounted(){
    await this.getMedezTxGoals();
   },
 };
 </script>
<style>

.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>

